module.exports = __webpack_public_path__ + "static/media/nest_of_swarm.0c781b56.png";